// umlaut-check: skip — "produktlinie"/"marke" u. Ä. sind technische
// Feldnamen; sichtbare Label-Texte tragen Umlaute korrekt.

import {markeLabel as lieferungsMarkeLabel} from "./format.js";

/**
 * Farb- und Beschriftungs-Zuordnung für die interaktive Lastwagen-Darstellung
 * (LkwLadung.jsx) - getrennt nach den beiden Klassifikationen, die im
 * Bereich Cosmos nebeneinander bestehen: die vier Produktlinien der
 * Bestellvorschläge (cosmos_artikel_parameter.produktlinie, Rückgabefeld
 * "produktlinie") und die freie Marke einer Lieferung/-position
 * (cosmos_lieferungen(-positionen).marke). "PREMIUM" heißt in dieser
 * Darstellung bewusst "MOLOTOW" (Auftrag 22.09.2026: "MOLOTOW, FLAME
 * Orange, FLAME Blue, BURNER") - das ist die Verkaufsmarke der
 * Premium-Produktlinie, nicht die Umbenennung des Felds selbst (Filter und
 * Artikel-Blatt zeigen weiterhin "PREMIUM").
 *
 * Die Farben sind bewusst kategorial und gut unterscheidbar, keine echten
 * Markenfarben - Details zu jeder einzelnen Palette liefert der Tooltip,
 * nicht die Füllfarbe.
 */
const PRODUKTLINIE_MARKE_LABEL = {
    PREMIUM: "MOLOTOW",
    FLAME_ORANGE: "FLAME Orange",
    FLAME_BLUE: "FLAME Blue",
    BURNER: "BURNER",
};

const PRODUKTLINIE_FARBE = {
    PREMIUM: "#0d6efd",
    FLAME_ORANGE: "#fd7e14",
    FLAME_BLUE: "#20c997",
    BURNER: "#6f42c1",
};

const LIEFERUNG_MARKE_FARBE = {
    Molotow: "#0d6efd",
    Burner: "#6f42c1",
    Flame: "#fd7e14",
    Cosmos: "#6c757d",
};

export const LADUNG_FARBE_UNBEKANNT = "#adb5bd";
export const LADUNG_FARBE_GEPLANT = "#adb5bd";

export function produktlinieMarkeLabel(produktlinie) {
    return PRODUKTLINIE_MARKE_LABEL[produktlinie] || produktlinie || "Unbekannt";
}

export function produktlinieFarbe(produktlinie) {
    return PRODUKTLINIE_FARBE[produktlinie] || LADUNG_FARBE_UNBEKANNT;
}

export function lieferungMarkeLabel(marke) {
    return lieferungsMarkeLabel(marke);
}

export function lieferungMarkeFarbe(marke) {
    return LIEFERUNG_MARKE_FARBE[marke] || LADUNG_FARBE_UNBEKANNT;
}
